"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const labels_1 = __importDefault(require("./labels"));
const react_i18next_1 = require("react-i18next");
const tags_1 = require("../../atoms/tags");
const typography_1 = require("../../shared/typography");
const icons_1 = require("../../atoms/icons");
const moment_1 = __importDefault(require("moment"));
const AppContexts_1 = require("../../shared/AppContexts");
const STag = (0, styled_components_1.default)(tags_1.Tag) `
  margin-top: 0;
`;
const SMember = styled_components_1.default.div `
  cursor: pointer;
  border-radius: 3px;
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  background-color: ${({ theme }) => theme.colors.whiteBase};
  padding: 1rem;

  &[data-visible="false"] {
    display: none;
  }
  &[data-selected="true"],
  &.active,
  &:hover {
    border-color: ${({ theme }) => theme.colors.greyBase};
  }

  h2 {
    margin: 0.5rem 0;
  }

  span {
    margin-left: 0;
  }

  p {
    font-size: 0.875rem;
  }
`;
const SNotifications = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
`;
const notificationKeyToIcon = {
    chat: ["fas", "comments-alt"],
    behaviour: ["fas", "book"],
    nutrition: ["fas", "utensils"],
    training: ["fas", "dumbbell"],
    recovery: ["fas", "bed"],
    measurement: ["fas", "weight"],
    life: ["fas", "address-book"],
    mind: ["fas", "comment"]
};
const Member = ({ onClick, member, selected = false }) => {
    moment_1.default.relativeTimeThreshold("h", 24);
    const [t, i18next] = (0, react_i18next_1.useTranslation)();
    const { timezone, timeFormat } = (0, AppContexts_1.useUserSettingsContext)();
    // TODO: TS - Remove translation types casting
    const i18n = t("sidebar.userDetailCard", {
        returnObjects: true
    });
    const subscriptionTypeTranslations = t("sidebar.userDetailCard.subscriptionType", {
        returnObjects: true
    });
    return (0, react_1.useMemo)(() => ((0, jsx_runtime_1.jsxs)(SMember, { id: member.id, "data-id": member.id, "data-visible": member.id ? true : false, "data-selected": selected, onClick: () => {
            onClick && onClick(member);
        }, children: [member.subscription && ((0, jsx_runtime_1.jsx)(STag, { subscription: member.subscription, children: member.subscription }, void 0)), member.isUpgraded && ((0, jsx_runtime_1.jsx)(STag, { variant: "silver", children: subscriptionTypeTranslations["upgraded"] }, void 0)), (0, jsx_runtime_1.jsx)(typography_1.H2, { children: member.name }, void 0), member.lastActiveRaw && ((0, jsx_runtime_1.jsxs)(typography_1.P, { children: [i18n["lastActivity"], moment_1.default
                        .utc(member.lastActiveRaw, timeFormat)
                        .locale(i18next.language)
                        .zone(timezone)
                        .fromNow()] }, void 0)), (0, jsx_runtime_1.jsx)(SNotifications, { children: member.notifications.map((notification) => ((0, jsx_runtime_1.jsx)(icons_1.IconWithIndicator, { icon: notificationKeyToIcon[notification.key], active: notification.active, onClick: (e) => {
                        e.stopPropagation();
                        onClick && onClick(member, notification.key);
                    } }, notification.key))) }, void 0), (0, jsx_runtime_1.jsx)(labels_1.default, { member: member }, void 0)] }, void 0)), [member]);
};
exports.default = Member;
//# sourceMappingURL=member.js.map